import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoreRedSmall = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 1.25,
			y: .75,
			width: 22.5,
			height: 22.5,
			rx: 11.25,
			stroke: "#FE7D6A",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12.5909,
			cy: 8.81796,
			r: 1.09091,
			fill: "#FE7D6A"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12.5909,
			cy: 11.9996,
			r: 1.09091,
			fill: "#FE7D6A"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12.5909,
			cy: 15.1817,
			r: 1.09091,
			fill: "#FE7D6A"
		})
	]
});
export default SvgMoreRedSmall;
